import { carrotDomain } from './carrotDomain';

const carrotUrl = `https://${carrotDomain()}`;
const amuiUrl = `https://my.${carrotDomain()}`;
const appUrl = `https://app.${carrotDomain()}`;
const dashboardUrl = `https://dashboard.${carrotDomain()}`;
const agencyUrl = `${dashboardUrl}/agency`;
const helpUrl = `https://help.${carrotDomain()}`;
const communityUrl = `https://community.${carrotDomain()}`;
const crmPricingUrl = `${carrotUrl}/crm-pricing/`;
const supportUrl = `${helpUrl}/support/`;
const pricingUrl = `${carrotUrl}/pricing/`;
const termsUrl = `${carrotUrl}/terms/`;
const privacyPolicyUrl = `${carrotUrl}/privacy/`;
const marketplaceUrl = `https://marketplace.${carrotDomain()}`;
const superAdminUrl = `https://admin.${carrotDomain()}`;
const contentUrl = `https://content.${carrotDomain()}`;
const carrotCrmUrl = `https://crm.${carrotDomain()}`;

function crmOpportunityUrl(teamId: string, opportunityId: string) {
  return `${carrotCrmUrl}/app/teams/${teamId}/opportunities/${opportunityId}`;
}

function dashboardAccountUrl(accountId: string | number) {
  return `${dashboardUrl}/accounts/${accountId}`;
}

function loginUrl(redirectUrl?: string) {
  if (redirectUrl) {
    return `${appUrl}/?redirect_to=${encodeURIComponent(redirectUrl)}`;
  }

  return appUrl;
}

function deepLinkToApp(path: string) {
  if (!path.startsWith('/')) throw new Error('path must start with /');
  return `${appUrl}/goto/?t=${appUrl}/account/site/*(ID)*${path}`;
}

function upgradePath(product: string, returnUrl: string) {
  return `/account/billing/upgrade?product=${product}&returnUrl=${encodeURIComponent(returnUrl)}`;
}

/**
 * Path to the Go page's route, with a destination, if specified
 * @example goPath('/account/{{accountId}}') -> '/go?to=/account/{{accountId}}'
 */
function goPath(to?: string) {
  const path = '/go';
  if (!to) {
    return path;
  }

  return `${path}?to=${to}`;
}

function subscriptionUpdatedPath(returnUrl: string) {
  return `/account/billing/updated?returnUrl=${encodeURIComponent(returnUrl)}`;
}

/**
 * @param siteId - WordPress site ID
 * @param path - Single site app path and query params, if any
 * @returns URL to single site app page
 */
function singleSiteAppUrl(siteId: number, path = '') {
  const pathWithLeadingSlash = path.replace(/^([^/])/, '/$1');
  return `${appUrl}/account/site/${siteId}${pathWithLeadingSlash}`;
}

/**
 * @param domain - WordPress site domain
 * @param path - WP Admin page URL with query params, if any
 * @returns URL to WP Admin page
 */
function wpAdminUrl(domain: string, path = '') {
  return `https://${domain}/wp-admin/${path}`.replace(
    'wp-admin//',
    'wp-admin/'
  );
}

const features = {
  seoTools: `${carrotUrl}/features/seo-tools/`,
};

export {
  agencyUrl,
  amuiUrl,
  appUrl,
  carrotCrmUrl,
  carrotUrl,
  communityUrl,
  contentUrl,
  crmOpportunityUrl,
  crmPricingUrl,
  dashboardAccountUrl,
  dashboardUrl,
  deepLinkToApp,
  features,
  goPath,
  helpUrl,
  loginUrl,
  marketplaceUrl,
  pricingUrl,
  privacyPolicyUrl,
  singleSiteAppUrl,
  subscriptionUpdatedPath,
  superAdminUrl,
  supportUrl,
  termsUrl,
  upgradePath,
  wpAdminUrl,
};
